import React from 'react'

import type { IconProps } from './types'

const Pill: React.FC<IconProps> = ({
  size = 40,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13.2995 1.69449C14.7592 1.30338 16.3143 1.50709 17.624 2.26093C18.9317 3.01821 19.8857 4.26317 20.2768 5.72281C20.6679 7.18245 20.4642 8.73761 19.7103 10.0473L17.286 14.2464L7.41328 8.54642L9.83766 4.34728C10.5949 3.0396 11.8399 2.0856 13.2995 1.69449Z"
        fill={color}
      />
      <path
        d="M16.5828 15.4643L6.69717 9.75676L4.28766 13.9602C3.53179 15.2694 3.32696 16.8252 3.71822 18.2854C4.10949 19.7457 5.0648 20.9906 6.374 21.7465C7.6832 22.5024 9.23905 22.7072 10.6993 22.3159C12.1595 21.9247 13.4045 20.9694 14.1603 19.6602L16.5828 15.4643Z"
        fill={color}
      />
    </svg>
  )
}

export default Pill
